exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".slide-enter-active,.slide-leave-active{transition:all .5s ease-in-out}.slide-enter,.slide-leave-to{opacity:0;transform:translateY(-20px)}.list-view{position:relative;width:80%;max-width:600px;margin:auto}.list-view-label-container{margin-top:.5rem;margin-bottom:1.5rem;text-align:center}.list-view-label-item{color:HSLA(0,0,32%,1);padding:.25rem .5rem;border-radius:10%}.list-view-item{border-bottom:1px solid #a9b6c5;display:block;padding:1rem 0 1.5rem;margin-bottom:1em;text-align:left;display:flex}.list-view-item-time{flex:0 0 20%;color:#a9b6c5;margin:0;padding:0}.list-view-item h3{flex:1,1,80%;font-size:1.5em;margin:0;margin-top:-.25em;padding:0}@media (max-width:500px){.list-view-item{flex-direction:column;padding:.5rem 0 .75rem}.list-view-item-time{margin-bottom:.2rem}.list-view-item h3{margin-top:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36b537b5","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/list-view.vue
// module id = 254
// module chunks = 0